import React from "react";
import { useParams } from "react-router-dom";
import { QuestionCard } from "./Questions-Card"; 
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import "./PhysicalDomain.css";

export const PhysicalDomain = () => {
  const { domain } = useParams();
  return (
    <div className="physical-domain">
      <div className="questioncard-domain">
      <QuestionCard
         domain={domain}
        headerTitle="PEARLI Self-Assessment"
        headerSubtitle="Reflect on your well-being, one domain at a time."
        breadcrumbs={[
          { icon: null, text: "Self Mindfullness", active: false },
          { icon: null, text: "PEARLI (General Life)", active: false },
          { icon: null, text: `${domain.charAt(0).toUpperCase() + domain.slice(1)} Well Being`, active: true }

        ]}
        
      />
      </div>
    </div>
  );
};
